import { composeIO } from 'react-compose-io'
import { modalEditarIO } from './ModalEditar.IO'
import { ModalEditarView } from './ModalEditar.View'

export const ModalEditar = composeIO(ModalEditarView, modalEditarIO)
